import { render, staticRenderFns } from "./ConfirmationOrder.vue?vue&type=template&id=063b44ca&"
import script from "./ConfirmationOrder.vue?vue&type=script&lang=js&"
export * from "./ConfirmationOrder.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationOrder.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./ConfirmationOrder.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports